"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSliderOptions = void 0;
var _constants = require("../constants");
const getSliderOptions = ({
  slider,
  isMobile
}) => ({
  breakpoints: {
    ..._constants.SMALL_BREAKPOINT_SETTINGS,
    ..._constants.MEDIUM_BREAKPOINT_SETTINGS
  },
  slides: {
    perView: 'auto',
    spacing: _constants.SPACING
  },
  loop: false,
  mode: isMobile ? 'free' : 'snap',
  ...slider
});
exports.getSliderOptions = getSliderOptions;
